import { Typography } from '@mui/material';
import { useLocalization } from '@ui-framework/index';
import { getWeekdays } from './constants';

function WeekDayHeader() {
  const { formatMessage } = useLocalization();
  return getWeekdays(formatMessage).map(h => (
    <Typography
      key={h.value}
      variant="caption"
      color="text.secondary"
      sx={{ textAlign: 'center', py: 0.5 }}>
      {h.shortLabel}
    </Typography>
  ));
}

export default WeekDayHeader;
